module.exports = __webpack_public_path__ + "static/media/gp5.745cdbff.webp";